module.exports = __webpack_public_path__ + "img/ufc_logo.f35e1fd0.svg";